import React from "react";

// Shared error message block used across pages and sections.
const ErrorState = ({
  message = "Something went wrong. Please try again.",
}) => {
  return (
    <div className="flex w-full flex-col items-center justify-center gap-3 py-16 text-center">
      <span className="flex h-11 w-11 items-center justify-center rounded-full bg-danger/10 text-danger">
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.75"
          strokeLinecap="round"
          className="h-6 w-6"
          aria-hidden="true"
        >
          <path d="M12 8v5M12 16.5v.01" />
          <circle cx="12" cy="12" r="9" />
        </svg>
      </span>
      <p className="font-semibold text-navy">{message}</p>
    </div>
  );
};

export default ErrorState;
